import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";
import { env as serverEnv } from "./server";

export const env = createEnv({
	extends: [serverEnv],
	server: {
		APP_ROLE: z.literal("web"),
		ADMIN_APP_URL: z.url().optional(),
		UPSTASH_REDIS_REST_URL: z.url().optional(),
		UPSTASH_REDIS_REST_TOKEN: z.string().optional(),
		UPSTASH_REDIS_READ_REST_TOKEN: z.string().optional(),
	},
	client: {
		NEXT_PUBLIC_SENTRY_DSN: z.string().url().optional(),
		NEXT_PUBLIC_SHOW_OTP: z.enum(["true", "false"]).optional(),
		NEXT_PUBLIC_FIREBASE_API_KEY: z.string().min(1),
		NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: z.string().min(1),
		NEXT_PUBLIC_FIREBASE_PROJECT_ID: z.string().min(1),
		NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: z.string().min(1),
		NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
		NEXT_PUBLIC_FIREBASE_APP_ID: z.string().min(1),
		NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID: z.string().optional(),
	},
	runtimeEnv: {
		APP_ROLE: process.env.APP_ROLE,
		ADMIN_APP_URL: process.env.ADMIN_APP_URL,
		UPSTASH_REDIS_REST_URL: process.env.UPSTASH_REDIS_REST_URL,
		UPSTASH_REDIS_REST_TOKEN: process.env.UPSTASH_REDIS_REST_TOKEN,
		UPSTASH_REDIS_READ_REST_TOKEN: process.env.UPSTASH_REDIS_READ_REST_TOKEN,
		NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
		NEXT_PUBLIC_SHOW_OTP: process.env.NEXT_PUBLIC_SHOW_OTP,
		NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
		NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN:
			process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
		NEXT_PUBLIC_FIREBASE_PROJECT_ID:
			process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
		NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET:
			process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
		NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID:
			process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
		NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
		NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID:
			process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
	},
	emptyStringAsUndefined: true,
});
